import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';
import { PaginatorType } from '../types/paginator';

export const getSmallFleets = (paginator: PaginatorType) => {
    const urlParams = new URLSearchParams(paginator as any);
    return axios.get(`${OCTOPUS_BASE_URL}/smallfleets?${urlParams.toString()}`);
};
